// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__tugPY","item":"PaymentsMobile_item__11-Az","label":"PaymentsMobile_label__3FY7B","amount":"PaymentsMobile_amount__NEcQM"};